var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1481_9844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.65625H24.0614V25.0114H0V2.65625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1481_9844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32274 4.04449C2.65303 4.04449 1.29463 5.5011 1.29463 7.29228V20.3754C1.29463 22.1665 2.65303 23.6232 4.32274 23.6232H19.7383C21.4087 23.6232 22.7671 22.1665 22.7671 20.3754V7.29228C22.7671 5.5011 21.4087 4.04449 19.7383 4.04449H4.32274ZM19.7383 25.0114H4.32274C1.9392 25.0114 0 22.932 0 20.3754V7.29228C0 4.7364 1.9392 2.65625 4.32274 2.65625H19.7383C22.1225 2.65625 24.0617 4.7364 24.0617 7.29228V20.3754C24.0617 22.932 22.1225 25.0114 19.7383 25.0114V25.0114Z",
    fill: "#050101"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47935 6.62953C5.12209 6.62953 4.83203 6.31924 4.83203 5.93542V0.69424C4.83203 0.311151 5.12209 0.00012207 5.47935 0.00012207C5.8366 0.00012207 6.12597 0.311151 6.12597 0.69424V5.93542C6.12597 6.31924 5.8366 6.62953 5.47935 6.62953",
    fill: "#050101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3849 6.62953C19.0277 6.62953 18.7383 6.31924 18.7383 5.93542V0.69424C18.7383 0.311151 19.0277 0.00012207 19.3849 0.00012207C19.7422 0.00012207 20.0322 0.311151 20.0322 0.69424V5.93542C20.0322 6.31924 19.7422 6.62953 19.3849 6.62953",
    fill: "#050101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1481_9844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 24,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.26202H23.3909V10.6503H0V9.26202Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1481_9844)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7445 10.6503H0.647314C0.290057 10.6503 0 10.34 0 9.95614C0 9.57305 0.290057 9.26202 0.647314 9.26202H22.7445C23.1017 9.26202 23.3911 9.57305 23.3911 9.95614C23.3911 10.34 23.1017 10.6503 22.7445 10.6503",
    fill: "#050101"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7689 14.6959C10.7689 15.454 10.1949 16.0694 9.48795 16.0694C8.78029 16.0694 8.20703 15.454 8.20703 14.6959C8.20703 13.9371 8.78029 13.3224 9.48795 13.3224C10.1949 13.3224 10.7689 13.9371 10.7689 14.6959",
    fill: "#050101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4798 19.937C6.4798 20.6958 5.90654 21.3105 5.19888 21.3105C4.49191 21.3105 3.91797 20.6958 3.91797 19.937C3.91797 19.1789 4.49191 18.5635 5.19888 18.5635C5.90654 18.5635 6.4798 19.1789 6.4798 19.937",
    fill: "#050101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7689 19.937C10.7689 20.6958 10.1949 21.3105 9.48795 21.3105C8.78029 21.3105 8.20703 20.6958 8.20703 19.937C8.20703 19.1789 8.78029 18.5635 9.48795 18.5635C10.1949 18.5635 10.7689 19.1789 10.7689 19.937",
    fill: "#050101"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.054 19.937C15.054 20.6958 14.4801 21.3105 13.7731 21.3105C13.0654 21.3105 12.4922 20.6958 12.4922 19.937C12.4922 19.1789 13.0654 18.5635 13.7731 18.5635C14.4801 18.5635 15.054 19.1789 15.054 19.937",
    fill: "#050101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.054 14.6959C15.054 15.454 14.4801 16.0694 13.7731 16.0694C13.0654 16.0694 12.4922 15.454 12.4922 14.6959C12.4922 13.9371 13.0654 13.3224 13.7731 13.3224C14.4801 13.3224 15.054 13.9371 15.054 14.6959",
    fill: "#050101"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7415 14.6959C19.7415 15.454 19.1683 16.0694 18.4606 16.0694C17.7536 16.0694 17.1797 15.454 17.1797 14.6959C17.1797 13.9371 17.7536 13.3224 18.4606 13.3224C19.1683 13.3224 19.7415 13.9371 19.7415 14.6959",
    fill: "#050101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.baa20c5a1e64dbf58a88d4892be8cb7d.svg";
export { ForwardRef as ReactComponent };